






















import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {CommonStatus} from "../../../enums/status";
import debounce from "lodash/debounce";
import {PartnerStore} from "../../../modules/partners/store";
import {PartnerParams} from "../../../modules/partners";
import PartnerLabel from "../../../modules/partners/List/components/Label.vue";
import {EmployeeParams} from "@/modules/employees/params";
import {EmployeeStore} from "@/modules/employees/store";

@Component({
    name: "PartnerSelector",
    components: {PartnerLabel}
})
export default class extends Vue {
    @Model("change")
    readonly partnerId!: string | string[];

    @Emit('change')
    handleChange(value: string) {
        if (value == undefined) {
            this.onSearch(value);
        }
        return value;
    }
    @Prop({type: Boolean, default: false})
    readonly disabled!: boolean;

    @Prop({type: Number, default: undefined})
    readonly type!: number;

    @Prop({type: String, default: "Chọn đối tác"})
    readonly placeholder!: string;

    @Prop({default: "default", type: String})
    readonly mode!: string;

    ids: string[] = [];

    async created() {
        try {
            const params = {...new PartnerParams(), limit: 100, status: CommonStatus.Active, type: this.type};
            await PartnerStore.listPartner({ params });
            this.ids = this.type ? PartnerStore.type[this.type] : PartnerStore.ids;
        } catch (e) {
            this.$message.error({content: e?.response?.data?.message || "Đã có lỗi xảy ra"});
        }
    }

    handleSearch = debounce(async (value: string, vm: any) => {
        const params = {...new PartnerParams(), limit: 100, search: value, status: CommonStatus.Active, type: vm.type};
        await PartnerStore.listPartner({ params, refresh: true });
        vm.ids = vm.type? PartnerStore.type[vm.type] : PartnerStore.ids;
        console.log(vm.ids);
    }, 500);

    onSearch(val: any) {
        console.log(val);
        this.handleSearch(val, this);
    }

    // private onSearch = debounce((value: string) => {
    //     const params = {...new PartnerParams(), search: value, status: CommonStatus.Active, type: this.type};
    //     PartnerStore.listPartner({ params });
    // }, 500);
}
